export const ProtocolInteractionType_AddProtocol = 'add-protocol';
export const ProtocolInteractionType_AddOrder = 'add-order';
export const ProtocolInteractionType_Graph = 'graph';
export const ProtocolInteractionType_PathwayDetails = 'pathway-details';
export const ProtocolInteractionType_RelatedFindings = 'related-findings';
export const dispositionType_Admit = 'admit';
export const dispositionType_Discharge = 'discharge';
//# sourceMappingURL=types.js.map